<template>
  <custom-dialog
    :show="show"
    :title="$t('dialog.userList.add_equip')"
    @toggleShow="handleClose"
    :appendToBody="true"
    width="398"
  >
    <div class="flex form" slot="main">
      <el-form
        ref="form"
        :rules="rules"
        :model="form"
        label-width="90px"
        label-position="left"
        hide-required-asterisk
      >
        <el-form-item
          :label="$t(item.label) + '：'"
          v-for="item in currentFormItem"
          :key="item.key"
          :prop="item.key"
        >
          <template v-if="item.inputType == 'select'">
            <el-select
              v-model="form[item.key]"
              style="width: 268px"
              size="small"
              :placeholder="$t(item.label)"
            >
              <el-option
                v-for="option in $t(item.selectKey)"
                :key="option.value"
                :label="option.label"
                :value="option.value"
              >
              </el-option>
            </el-select>
          </template>
          <template v-else-if="item.inputType == 'input'">
            <template v-if="item.key == 'elevation'">
              <div class="flex">
                <el-input
                  v-model="form[item.key]"
                  :placeholder="$t(item.label)"
                ></el-input>
                <span style="margin: 0 12px">m</span>
                <el-button type="primary" class="btn save" size="small">
                  {{ $t("label.model.getLonlat") }}
                </el-button>
              </div>
            </template>
            <template v-else>
              <el-input
                size="small"
                style="width: 268px"
                v-model="form[item.key]"
                :placeholder="$t(item.label)"
              ></el-input>
            </template>
          </template>
        </el-form-item>
      </el-form>
    </div>

    <div class="flex btns" slot="footer">
      <el-button
        type="success"
        class="btn cancel"
        size="small"
        @click="handleClose()"
      >
        {{ $t("public.close") }}
      </el-button>
      <el-button type="primary" class="btn save" size="small" @click="add">
        {{ $t("public.save") }}
      </el-button>
    </div>
  </custom-dialog>
</template>

<script>
import { addThirdDevice } from "@/api/index";
import CustomDialog from "../../../components/public/customDialog";
export default {
  name: "EditSn",
  components: {
    CustomDialog,
  },

  props: {
    show: {
      type: Boolean,
      default: false,
    },
    row: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    // 校验账号
    var validateSN = (rule, value, callback) => {
      if (!value) {
        callback(new Error("请输入账号"));
      } else {
        callback();
      }
    };
    return {
      formItem: [
        {
          label: "dialog.userList.query_sn",
          key: "sn",
          inputType: "input",
        },
      ],
      form: {
        sn: "",
      },
      rules: {
        sn: [{ required: true, validator: validateSN, trigger: "blur" }],
      },
    };
  },
  computed: {
    title() {
      if (this.rowInfo && this.rowInfo.id) {
        return this.$t("dialog.userList.edit_title") + "-" + this.rowInfo.name;
      } else {
        return this.$t("dialog.userList.add_title");
      }
    },
    currentFormItem() {
      if (this.rowInfo && this.rowInfo.id) {
        return this.formItem.filter(
          (f) => f.key == "accountType" || f.key == "contact"
        );
      } else {
        return this.formItem;
      }
    },
  },
  watch: {
    show: {
      handler(val) {
        this.form = {
          sn: "",
        };
      },
      deep: true,
    },
  },
  methods: {
    handleClose(done) {
      this.$emit("toggleShow", false);
      this.$refs.form.clearValidate();
    },
    add() {
      let param = {
        sn: this.form.sn,
        third: this.row.id,
        method: 1, // 1 设备码添加  2 导入
      };
      this.$refs["form"].validate((valid) => {
        if (valid) {
          addThirdDevice(param).then((res) => {
            if (res.code === 200) {
              this.$message({
                type: "success",
                // message: "设备添加成功！",
                message: this.$t("dialog.userList.add_success_info"),
                duration: 2000,
              });
              this.$emit("toggleShow", false);
              // this.$emit("refush");
            } else {
              this.$message({
                type: "warning",
                message: res.msg,
                duration: 2000,
              });
            }
          });
        } else {
          return;
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.btns {
  justify-content: center;
  .btn {
    width: 180px;
    height: 32px;
  }
  .save {
    background-color: $main_color;
    border-color: $main_color;
    margin-left: 30px;
  }
  .cancel {
    border-color: $main_color;
    background-color: #fff;
    color: $main_color;
  }
}
.form {
  justify-content: center;
}
</style>
